<template>
    <div class="page-tabs-box">
         <el-tabs v-model="activeName" @tab-click="clickEvent">
            <el-tab-pane
                label="证件信息管理"
                name="1"
                :link="`/user/realName/list`"
            ></el-tab-pane>
            <el-tab-pane
                v-if="$utils.have('/commonPerformer/authList')"
                label="人脸验证管理"
                name="2"
                :link="`/user/realName/faceManage`"
            ></el-tab-pane>
            <el-tab-pane
                v-if="$utils.have('/commonPerformer/exemptList')"
                label="免检证件管理"
                name="3"
                :link="`/user/realName/exemption`"
            ></el-tab-pane>
         </el-tabs>
    </div>
</template>
<script>
export default {
    props: {
        name: {
            type: String,
            default: "1",
        },
    },
    data() {
        return {
            activeName: this.name,
        };
    },
    methods: {
        clickEvent(tab) {
            if (tab.$attrs.link) this.$router.push(tab.$attrs.link);
        },
    },
};
</script>

<style lang="scss" scoped>
</style>